import { setLoggedInUser } from "../util/sessionUtil";

export default function loginReducer(state = {
  blocking: false
}, action) {
  switch (action.type) {
    case "SET_BLOCKING_STATE":
      return Object.assign({}, state, { blocking: action.payload });
    case "USER_DATA":
      var loggedInUser = {
        // fullName: action.payload.userName,
        // roles: action.payload.roles,
        // fullName:"vaibhavsharma576@gmail.com",
        // roles:"EDOC TME Forwarder",
        loggedIn: true,
        user: action.user,
      };
      console.log(loggedInUser);
     // setLoggedInUser(loggedInUser);
      return Object.assign({}, state, { loggedInUser: loggedInUser });
    default:
      return state;
  }
};